export default "__VITE_ASSET__C4kGQd$Z__"